module.exports = __webpack_public_path__ + "static/media/restaurant-13.6ca08f88.jpg";